// 4 sidebar section headers in the v3 admin NavigationBar IA, per Figma
// 10972:23798. Mirrors `NavSectionV3` (retailer) but kept separate so admin
// sections can evolve independently. String values are namespaced
// (`Admin*`) to avoid collisions with retailer values if maps are ever merged.
export enum AdminNavSectionV3 {
  Global = 'AdminGlobal',
  Commerce = 'AdminCommerce',
  Operations = 'AdminOperations',
  Admin = 'AdminAdmin',
}

// Single source of truth for the i18n key per section. Global is intentionally
// omitted — its absence makes the renderer suppress the section header,
// matching v2 admin's "no section headers" layout.
export const ADMIN_NAV_SECTION_TITLES: Partial<Record<AdminNavSectionV3, string>> = {
  [AdminNavSectionV3.Commerce]: 'navV3.section.commerce.title',
  [AdminNavSectionV3.Operations]: 'navV3.section.operations.title',
  [AdminNavSectionV3.Admin]: 'navV3.section.admin.title',
}
